export default {
    getList: {
        getPendList: async function (params) {
            let option = {
                url: '/api/v1/user/app/alerts/untreated2',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/user/site' + '/' + params.site_id,
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        creatNewWork: async function (params) {
            let option = {
                url: '/api/v1/worksheet/create',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}